<template>
  <div>
    <div class="bar menu">
      <button class="button" @click="getFortnoxCustomerNumbers" :disabled="working">Hämta Fortnox kundnummer</button>
      <button class="button" @click="getInternalCustomers" :disabled="working">Skapa kunder i Fortnox</button>
    </div>

    <div class="columns">

      <div class="column">
        <h4>THE CONSOLE</h4>
        <div class="console-output">
          <div v-for="message in fortnoxMessageList" :key="message">
            <div>{{ message }}</div>
          </div>
        </div>
      </div>

      <div class="column">
        <h4>THE RESULT</h4>
          <div v-if="fortnoxResultList.length > 0">
          <table class="table is-striped" style="display: block; max-height: 600px; overflow-y: scroll; width: 100%;">
            <thead>
              <tr>
                <th>Internt ID</th>
                <th>Namn</th>
                <th>Fortnox-nummer</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in fortnoxResultList" :key="item.customerId">
                <td>{{ item.customerId }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.fortnoxCustomerNumber }}</td>
              </tr>
            </tbody>
          </table>

          <button v-if="mode === 'import'" class="button is-primary" @click="approveImport" :disabled="working">Godkänn ändringar</button>

          <div v-if="mode === 'export'">
            <button class="button is-primary" @click="approveCreateCustomers" :disabled="working">Godkänn</button>
            <span style="display: inline-block; margin-left: 20px;" :class="{ dimmed: !working }">{{ this.createCustomersProgress }} / {{ this.fortnoxResultList.length }}</span>
          </div>

        </div>

        <div v-if="!working && fortnoxMessageList.length > 0 && fortnoxResultList.length === 0" style="font-style: italic">Det finns inget att godkänna</div>
      </div>
    </div>

    <div class="bar" v-if="fortnoxMessageList.length > 0">
      <button class="button" @click="clearMessages">Rensa</button>
    </div>

  </div>
</template>

<script>

import $axios from '@/axios-instance.js'

export default {
  data () {
    return {
      fortnoxMessageList: [],
      fortnoxResultList: [],
      working: false,
      mode: 'import',
      createCustomersProgress: 0
    }
  },
  methods: {
    getFortnoxCustomerNumbers () {
      this.clearMessages()
      this.working = true
      this.mode = 'import'
      $axios.get(`${process.env.ROOT_API}/dev/import-customers-from-fortnox`).then(response => {
        this.$toast(response.data.message, 'success')
        this.working = false
      })
    },
    approveImport () {
      this.working = true
      $axios.post(`${process.env.ROOT_API}/dev/import-customers-from-fortnox-approve`, this.fortnoxResultList).then(response => {
        this.$toast(response.data.message, 'success')

        this.$alertOptions({
          title: 'Klappat och klart!',
          text: 'Kundnummer från Fortnox sparade internt',
          type: 'success',
          confirmButtonText: 'Ok',
          allowOutsideClick: false
        }).then(x => {
          this.clearMessages()
        })

        this.working = false
      })
    },

    getInternalCustomers () {
      this.clearMessages()
      this.working = true
      this.mode = 'export'
      $axios.get(`${process.env.ROOT_API}/dev/create-customers-in-fortnox`).then(response => {
        this.$toast(response.data.message, 'success')
        this.working = false
      })
    },

    approveCreateCustomers () {
      this.working = true
      $axios.post(`${process.env.ROOT_API}/dev/create-customers-in-fortnox-approve`, this.fortnoxResultList).then(response => {
        this.$toast(response.data.message, 'success')

        this.$alertOptions({
          title: 'Klappat och klart!',
          text: 'Alla kunder skapade i Fortnox',
          type: 'success',
          confirmButtonText: 'Ok',
          allowOutsideClick: false
        }).then(x => {
          this.clearMessages()
        })

        this.working = false
      })
    },

    clearMessages () {
      this.fortnoxMessageList = []
      this.fortnoxResultList = []
    },
    onFortnoxCustomerIntegrationMessage (message) {
      this.fortnoxMessageList.push(message)
    },
    onFortnoxCustomerIntegrationResult (hits) {
      this.fortnoxResultList = hits
    },
    onFortnoxCreateCustomersProgress (progress) {
      this.createCustomersProgress = progress
    }
  },

  created () {
    this.$messageHub.$on('fortnox-customer-integration-message', this.onFortnoxCustomerIntegrationMessage)
    this.$messageHub.$on('fortnox-customer-integration-result', this.onFortnoxCustomerIntegrationResult)
    this.$messageHub.$on('fortnox-create-customers-progress', this.onFortnoxCreateCustomersProgress)
  },

  beforeDestroy () {
    this.$messageHub.$off('fortnox-customer-integration-message', this.onFortnoxCustomerIntegrationMessage)
    this.$messageHub.$off('fortnox-customer-integration-result', this.onFortnoxCustomerIntegrationResult)
    this.$messageHub.$off('fortnox-create-customers-progress', this.onFortnoxCreateCustomersProgress)
  }
}
</script>

<style lang="scss" scoped>
  .bar {
    background-color: rgba(0, 0, 0, 0.1);
    padding: 0.5rem;
    border-radius: 0.5rem;

    &.menu {
      margin-bottom: 2rem;
    }
  }

  @mixin scanlines($color, $height: 1px, $angle: 0, $opacity: 0.2) {
    position: relative;
    &:after {
      background-image: repeating-linear-gradient(to bottom, transparent 0 ,transparent $height, $color $height, $color $height * 2);
      background-size: 100% $height * 2, cover;
      transform-origin: 50% 50%;
      transform: rotate($angle);
      content: '';
      opacity: $opacity;
      position: absolute;
      min-width: 100%;
      min-height: 100%;
    }
  }

  .console-output {
    font-family: 'Courier New', Courier, monospace;
    background-color: #000;
    color: #3fa81f;
    min-height: 50px;
    padding: 10px;
    margin-bottom: 0.75rem;
    background-size: cover;
    background-image: repeating-linear-gradient(to bottom, transparent 0 ,transparent 1px, rgba(63, 168, 31, 0.4) 1px, rgba(63, 168, 31, 0.4) 2px);
  }
  .dimmed {
    opacity: 0.4;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings/DevPageViews/Fortnox.vue